import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const AlertInformationFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="alertInformationFilled" ref={ref} {...props}>
    <path d="M21.75,12A9.75,9.75,0,1,1,12,2.25,9.76,9.76,0,0,1,21.75,12ZM13,17.13V12.5a1,1,0,0,0-2,0v4.63a1,1,0,0,0,2,0Zm.34-9.25A1.34,1.34,0,1,0,12,9.22,1.34,1.34,0,0,0,13.34,7.88Z" />
  </Icon>
)) as IconWithRender;

AlertInformationFilledIcon.displayName = 'AlertInformationFilledIcon';
AlertInformationFilledIcon.renderIcon = (props) => (
  <AlertInformationFilledIcon {...props} />
);
export default AlertInformationFilledIcon;
